(function(){
    angular
        .module('appback')
        .directive('ngLiquidos122', liquidos122);

        liquidos122.$inject = ['ResultadosService','$timeout'];
        function liquidos122(ResultadosService,$timeout){
            return {
	            //require: 'ngModel',
	            templateUrl: '/backend/resultadopeticion/template?name=liquidos122.twig',
		          scope: {
                  //ngModel : '=',
                  item: '=',
                  animal: '=',
                  centro:'='
              	},
            	link: function (scope, element, $attrs) {
		            return $timeout(function () {
		            	scope.loadingFields = false;
		            	if(!scope.item.resultado){
			            		scope.item.resultado = { extra : { resultado : { celulas : [{}] }}};
		            	}else{
			            	if(!scope.item.resultado.extra){
			            		scope.item.resultado.extra = { resultado : { celulas : [{}] }};
				            }
				        }

				        scope.subanaliticas = [];
                    	scope.loading = true;
		            	ResultadosService.getSubanaliticasByAnalitica(scope.item.analitica_id,scope.animal.especie_id,scope.centro.idioma_code,function(data){
			               scope.subanaliticas = data.subanaliticas;
                    		scope.loading = false;
			            });

		            	function format(icon) {
	                        var originalOption = icon.element;
	                          var str = "";
	                          if(typeof $(originalOption).data('icon') != 'undefined'){
	                            str+='<i class="icon alt'+$(originalOption).data('icon')+'"></i> <span>'+icon.text+'</span>';
	                            return $(str+" ");
	                          }else{
	                            return icon.text || icon.value;
	                          }
	                     }

	                    scope.borrarCelula = function(index){
	                     	scope.item.resultado.extra.resultado.celulas.splice(index,1);
	                    }

	                    scope.nuevaCelula = function(){
	                    	scope.item.resultado.extra.resultado.celulas.push({});
	                    }

	                    scope.comprobarDiag = function(){
	                     	if(scope.item.resultado.extra.resultado.tejido && scope.item.resultado.extra.resultado.diagnostico){
	                     		//COMPROBAMOS SI TENEMOS QUE RELLENAR
	                     		ResultadosService.getDiagnosticoPlantilla(scope.item.resultado.extra.resultado.tejido,scope.item.resultado.extra.resultado.diagnostico,scope.centro.idioma_code,function(data){
	                     			if(data.plantilla){
	                     				scope.item.resultado.extra.resultado = angular.merge(scope.item.resultado.extra.resultado, data.plantilla);
	                     				scope.loadingFields = true;
	                     				$timeout(function(){
	                     					scope.loadingFields = false;
	                     				})
	                     			}
	                     			//console.log(data);
					               //scope.subanaliticas = data.subanaliticas;
					            });

	                     	}
	                     }


		            	scope.optionsAtributos = {
	                		ajax: {
		                        url: "/backend/resultadopeticion/select2atributos",
		                        dataType: 'json',
		                        delay: 250,
		                        data: function (params) {
		                          return {
		                            q: params.term, // search term
		                            page: params.page,
		                            field: 'nombre',
		                            per_page: 20,
		                            nodetype:'valoresatt'
		                          };
		                        },
		                        processResults: function (data, params) {
		                          params.page = params.page || 1;
		                          return {
		                            results: data.items,
		                            pagination: {
		                              more: (params.page * 1) < data.total_count
		                            }
		                          };
		                        },
		                        cache: true
		                    },
		                    templateSelection: format,
		                    templateResult: format
	                	}

	                	scope.optionsSelect2 = { 
		            		ajax: {
		                        url: "/backend/altcrm/content/select2",
		                        dataType: 'json',
		                        delay: 250,
		                        data: function (params) {
		                          return {
		                            q: params.term, // search term
		                            page: params.page,
		                            field: 'nombre',
		                            per_page: 20,
		                            //nodetype:'microorganismo'
		                          };
		                        },
		                        processResults: function (data, params) {
		                          params.page = params.page || 1;
		                          return {
		                            results: data.items,
		                            pagination: {
		                              more: (params.page * 1) < data.total_count
		                            }
		                          };
		                        },
		                        cache: true
		                    },
		                    templateSelection: format,
		                    templateResult: format
	                	};


	                	scope.optionsTiposMuestra = {
	                		ajax: {
		                        url: "/backend/resultadopeticion/tiposmuestra",
		                        dataType: 'json',
		                        delay: 250,
		                        data: function (params) {
		                          return {
		                            q: params.term, // search term
		                            page: params.page,
		                            field: 'nombre',
		                            per_page: 20,
		                            nodetype:'tipomuestra',
		                            analitica_id:scope.item.analitica.id
		                          };
		                        },
		                        processResults: function (data, params) {
		                          params.page = params.page || 1;
		                          return {
		                            results: data.items,
		                            pagination: {
		                              more: (params.page * 1) < data.total_count
		                            }
		                          };
		                        },
		                        cache: true
		                    },
		                    templateSelection: format,
		                    templateResult: format
	                	}

	                	$(document).on('change',".nucleo",function(){
	                		////console.log($(this).text());
	                		var valor = $(this).closest(".panel").find("select.nucleo option[value!='']:selected").map(function(){
			                  return $(this).text();
			                }).get();
	                		$(this).closest('.panel').find('.nucleodiv').text(valor.join(" / "));
	                	
	                		////console.log(valor);
	                		
			        	});

			        	$(document).on('change',".citoplasma",function(){
	                		////console.log($(this).text());
	                		var valor = $(this).closest(".panel").find("select.citoplasma option[value!='']:selected").map(function(){
			                  return $(this).text();
			                }).get();
	                		$(this).closest('.panel').find('.citodiv').text(valor.join(" / "));
	                	
	                		////console.log(valor);
	                		
			        	});

			        	$(document).on('change',".morfo",function(){
	                		////console.log($(this).text());
	                		var valor = $(this).closest(".panel").find("select.morfo option[value!='']:selected").map(function(){
			                  return $(this).text();
			                }).get();
	                		$(this).closest('.panel').find('.morfodiv').text(valor.join(" / "));
	                	
	                		////console.log(valor);
	                		
			        	});

	                	
	                	
			        });

					
		        }
          }
      }
})();